export { default as enGB } from './en-GB/strings.json';
export { default as daDK } from './da-DK/strings.json';
export { default as deDE } from './de-DE/strings.json';
export { default as esES } from './es-ES/strings.json';
export { default as frFR } from './fr-FR/strings.json';
export { default as itIT } from './it-IT/strings.json';
export { default as nlNL } from './nl-NL/strings.json';
export { default as svSE } from './sv-SE/strings.json';
export { default as enUS } from './en-US/strings.json';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/Stepper/localization/index.js
// module id = 1240
// module chunks = 0